var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"sticky-top z-1000"},[_c('NavHeader'),_c('NavMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }